import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-category-view',
  templateUrl: './category-view.component.html',
  styleUrls: ['./category-view.component.css']
})
export class CategoryViewComponent implements OnInit {
  whatFor: Array<any> = [];
  operations: Array<any> = [];
  units: Array<any> = [];
  postoutcomes = [];
  category: any;
  loagActivityData: any = null;
  activityData: any;
  createGoal: Boolean = false;
  invalid: Boolean = false;
  logActivity: Boolean = false;
  logManually: Boolean = false;
  catimage: String;
  url = this.apiservice.url + '/uploads/';
  range;
  showPages = ['10', '20', '50', '100', '200']
  constructor(
    public translations: TranslationService,
    private route: ActivatedRoute,
    private apiservice: ApiService
  ) { }

  ngOnInit() {
    this.apiservice.getUnits().subscribe((res: any) => this.units = res.data);
    this.apiservice.getWhats().subscribe((res: any) => this.whatFor = res.data);
    this.apiservice.getOperations().subscribe((res: any) => this.operations = res.data);
    this.getData();
  }


  getData() {
    if (this.apiservice.user.profiles) {
      this.apiservice.getCategoryById(this.route.snapshot.paramMap.get('cat_id'), this.apiservice.user._id).subscribe((res: any) => {
        this.category = res.data;
        this.category['category']['goals'] = this.category.goals.map(cat => cat);
        this.category.category.goals = this.category.category.goals.map(g => {
          let outcomes = [];
          g['collapse'] = false;
          g['new'] = false;
          g['edit'] = null;
          g['formData'] = { name: '', description: '', what: '', howmuch: '', operation: '', unit: '', percentage: 0, deadline: '', startYet: false, repeats: 'false', frequency: 'daily' }
          g['formDataEdit'] = { name: '', description: '', what: '', howmuch: '', operation: '', unit: '', percentage: 0, deadline: '', startYet: false }
          g.outcomes.forEach(ou => {
            if (ou.status && ou.status == 1) {
              outcomes.push(ou);
              if (ou.frequency) {
                let recurrings = this.getRecurringOutcomes(ou);
                recurrings.forEach(el => {
                  outcomes.push(el);
                })
              }
            }
          });
          g.outcomes = outcomes;
          return g;
        });
        this.catimage = this.category.category.image ? this.category.category.image : 'assets/images/login-bg.jpg';
      })
    } else {
      this.apiservice.getCreatedCategoryById(this.route.snapshot.paramMap.get('cat_id'), this.apiservice.user._id).subscribe((res: any) => {
        this.category = res.data;
        this.category['category'] = this.category;
        this.category.category.goals = this.category.category.goals.map(g => {
          let outcomes = [];
          g['collapse'] = false;
          g['new'] = false;
          g['edit'] = null;
          g['formData'] = { name: '', description: '', what: '', howmuch: '', operation: '', unit: '', percentage: 0, deadline: '', startYet: false, repeats: 'false', frequency: 'daily' }
          g['formDataEdit'] = { name: '', description: '', what: '', howmuch: '', operation: '', unit: '', percentage: 0, deadline: '', startYet: false }
          g.outcomes.forEach(ou => {
            if (ou.status && ou.status == 1) {
              outcomes.push(ou);
              if (ou.frequency) {
                let recurrings = this.getRecurringOutcomes(ou);
                recurrings.forEach(el => {
                  outcomes.push(el);
                })
              }
            }
          });
          g.outcomes = outcomes;
          return g;
        });
        console.log(this.category.category.goals)
        this.catimage = this.category.category.image ? this.category.category.image : 'assets/images/login-bg.jpg';
      });
    }
  }


  getRecurringOutcomes(ou) {
    let outcomes = []
    if (ou.frequency == 'daily') {
      let days: any = moment.duration(moment().diff(moment(ou.createdAt))).asDays();
      if (days > 0) {
        days = parseInt(days);
        for (let i = 1; i <= days; i++) {
          outcomes.push(this.outcomeObjToPush(ou, i, 'd'));
        }
      }
    } else if (ou.frequency == 'weekly') {
      let weeks: any = moment.duration(moment().diff(moment(ou.createdAt))).asWeeks();
      if (weeks > 0) {
        weeks = parseInt(weeks);
        for (let i = 1; i <= weeks; i++) {
          outcomes.push(this.outcomeObjToPush(ou, i, 'w'));
        }
      }
    } else if (ou.frequency == 'monthly') {
      let months: any = moment.duration(moment().diff(moment(ou.createdAt))).asMonths();
      if (months > 0) {
        months = parseInt(months);
        for (let i = 1; i <= months; i++) {
          outcomes.push(this.outcomeObjToPush(ou, i, 'm'));
        }
      }
    } else if (ou.frequency == 'yearly') {
      let years: any = moment.duration(moment().diff(moment(ou.createdAt))).asWeeks();
      if (years > 0) {
        years = parseInt(years);
        for (let i = 1; i <= years; i++) {
          outcomes.push(this.outcomeObjToPush(ou, i, 'y'));
        }
      }
    }
    return outcomes;
  }


  outcomeObjToPush(ou, i, dd) {
    let createdAt = moment(ou.createdAt).add(i, dd);
    return {
      createdAt: createdAt, updatedAt: createdAt, unit: ou.unit, percentage: 100,
      operation: ou.operation, howmuch: ou.howmuch, deadline: createdAt, what: ou.what, createdBy: ou.createdBy, name: ou.name
    }
  }



  rangeValue(event) {
    this.range = event.target.value;
  }

  closeGoalForm(event) {
    this.createGoal = false;
    if (event) {
      this.getData();
    }
  }

  save(index) {
    this.invalid = false;
    let that = this;

    let goal = this.category.category.goals[index]._id;
    let formData = this.category.category.goals[index]['formData'];
    formData['name'] = formData.what + ' ' + formData.operation + ' ' + formData.howmuch + ' ' + formData.unit;
    Object.keys(formData).forEach(function (key) {
      if (key !== 'description' && key !== 'percentage' && key !== 'deadline' && key !== 'startYet' && formData[key] == '') {
        that.invalid = true;
      }
    });
    if (this.invalid) {
      return
    }
    if (formData.startYet) {
      formData['percentage'] = 0;
    }
    if (formData.repeats == 'false') {
      delete formData.frequency;
    }
    formData['goal'] = goal;
    formData['createdBy'] = this.apiservice.user._id;
    this.apiservice.createOutcome(formData).subscribe((res: any) => {
      this.getData();
    });
  }

  logActiviy(category, goal, outcome) {
    this.loagActivityData = { category: category._id, goal: goal._id, outcome: outcome._id };
    this.logActivity = true;
  }

  openManualForm(event) {
    this.activityData = event.activityData;
    this.postoutcomes = event.postoutcomes;
    this.logManually = true;
  }

  formatTime(time) {
    if (time) {
      return moment(time).format('MMM DD');
    }
    return null;
  }

  deleteButForOutcome(outcome) {
    if (outcome.createdBy && outcome.createdBy == this.apiservice.user._id) {
      return true;
    }
    return false;
  }

  deleteButForGoal(goal) {
    if (goal.createdBy && goal.createdBy == this.apiservice.user._id) {
      return true;
    }
    return false;
  }


  deleteOutcome(id) {
    this.apiservice.deleteOutcome(id).subscribe((res: any) => {
      this.getData();
    });
  }

  deleteGoal(id) {
    this.apiservice.deleteGoals([id]).subscribe((res: any) => {
      this.getData();
    });
  }

  editOutcome(ci, outcome) {
    this.category.category.goals[ci]['formDataEdit'] = { id: outcome._id, name: outcome.name, description: outcome.description, what: outcome.what ? outcome.what : null, howmuch: outcome.howmuch ? outcome.howmuch : null, operation: outcome.operation ? outcome.operation : null, unit: outcome.unit ? outcome.unit : null, startYet: false };
    if (outcome.frequency) {
      console.log(outcome.frequency)
      this.category.category.goals[ci]['formDataEdit']['frequency'] = outcome.frequency;
    }
    if (outcome.percentage) {
      this.category.category.goals[ci]['formDataEdit']['percentage'] = outcome.percentage;
    }
    if (outcome.deadline) {
      this.category.category.goals[ci]['formDataEdit']['deadline'] = outcome.deadline;
    }
    this.category.category.goals[ci]['edit'] = outcome;
  }


  editSubmit(ci) {
    let formData = this.category.category.goals[ci]['formDataEdit'];
    formData['name'] = formData.what + ' ' + formData.operation + ' ' + formData.howmuch + ' ' + formData.unit;
    this.apiservice.updateOutcome(formData).subscribe((res: any) => {
      this.getData();
    });
  }


}
